/**
 * #post_message.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
/**
 * Blocks only.
 *
 * @deprecated
 */
export var WebViewInternalMessageScope;
(function (WebViewInternalMessageScope) {
    /** CLIENT - Message is intended for the client only */
    WebViewInternalMessageScope[WebViewInternalMessageScope["CLIENT"] = 0] = "CLIENT";
    WebViewInternalMessageScope[WebViewInternalMessageScope["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(WebViewInternalMessageScope || (WebViewInternalMessageScope = {}));
